var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SubmitButtonMagenta',{directives:[{name:"allowed",rawName:"v-allowed.editor",modifiers:{"editor":true}}],attrs:{"loading":_vm.loading,"spinner-color":"#fff"},on:{"click":_vm.postTemplate}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }